import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './CookieConsent.css';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    try {
      const consent = localStorage.getItem('cookieConsent');
      if (!consent) setShowBanner(true);
    } catch {
      setShowBanner(true);
    }
  }, []);

  useEffect(() => {
    if (!showBanner) {
      document.body.classList.remove('has-cookie-bar');
      return undefined;
    }
    document.body.classList.add('has-cookie-bar');
    return () => document.body.classList.remove('has-cookie-bar');
  }, [showBanner]);

  const handleAccept = () => {
    try {
      localStorage.setItem('cookieConsent', 'accepted');
    } catch {
      /* private mode — still hide */
    }
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="cookie-bar" role="dialog" aria-label="Cookie notice">
      <div className="cookie-bar-inner">
        <p className="cookie-bar-text">
          We use cookies to keep the site working smoothly.{' '}
          <Link to="/privacy">Privacy</Link>
        </p>
        <div className="cookie-bar-actions">
          <button
            type="button"
            className="cookie-bar-btn cookie-bar-btn-accept"
            onClick={handleAccept}
          >
            OK, got it
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
